import React, { useState, useEffect } from "react";
import AppointmentDateCard from "./AppointmentDateCard/AppointmentDateCard";
import SelectBox from "devextreme-react/select-box";
import styles from "./BookAnAppointment.module.css";
import DoctorCard from "./DoctorCard/DoctorCard";
import SearchBar from "material-ui-search-bar";
import Button from "@mui/material/Button";
import moment from "moment-timezone";
import { useDispatch } from "react-redux";

import axios from "axios";
import DoctorSlots from "./DoctorSlots/DoctorSlots";
import { SetError } from '../../redux-store/actions';

const BookAnAppointment = ({
  doctorList,
  selectDoctor,
  selectAppointmentTime,
  onClose,
  selectedAppointmentDate,
  centerId,
  selectedDateTime
}) => {
  let currentDate = new Date();
  let nextSevenDay = new Date();
  nextSevenDay = nextSevenDay.setDate(nextSevenDay.getDate() + 1);

  const dispatch= useDispatch()

  const [selectedTimeSlot, setSelectedTimeSlot] = useState("");
  const [clickedFetchButton, setClickedFetchButton] = useState([]);
  const [infoText, setInfoText] = useState(null);

  const [selectedDoctor, setSelectedDoctor] = useState("");

  const [searchValue, setSearchValue] = useState("");
  const [doctors, setDoctors] = useState([]);
  const [storedDoctorList, setStoredDoctorList] = useState([]);
  const [fromDate, setFromDate] = useState(currentDate);
  const [toDate, setToDate] = useState(nextSevenDay);
  const [dateRangeList, setDateRangeList] = useState([]);
  useEffect(() => {
    if (Array.isArray(doctorList)) {
      setDoctors(() => [...doctorList]);
      setStoredDoctorList(() => [...doctorList]);
    }
  }, []);
  const searchBarhandler = (searched) => {
    setSearchValue(searched);
    let filterDoctorList = doctors.filter((doctor) =>
      doctor.doctor_name.toLowerCase().includes(searched.toLowerCase())
    );
    setDoctors(() => [...filterDoctorList]);

    if (!searched.length) {
      setDoctors(() => [...storedDoctorList]);
    }
  };

  const onCancelSearch = () => {
    setDoctors(() => [...storedDoctorList]);
  };

  const fetchingAvailableSlots = () => {
    if (selectedDoctor===""){
      setInfoText("Please select a doctor .");
      
      return 
    }
    selectedAppointmentDate(null)
    selectAppointmentTime(null)
    if (toDate && fromDate) {
      let FromDate = moment(fromDate).format("YYYY-MM-DD");
      let ToDate = moment(toDate).format("YYYY-MM-DD");
      const diff = moment(ToDate, "YYYY-MM-DD").diff(
        moment(FromDate, "YYYY-MM-DD"),
        "days"
      );

      if (
        moment(fromDate).format("YYYY-MM-DD") >
        moment(toDate).format("YYYY-MM-DD")
      ) {
        setInfoText("From Date can not be greater than To date.");

        return;
      }
      if (diff >= 7) {
        setInfoText("Please specify the day range less than 7 days.");

        return;
      }

      setClickedFetchButton((prevState) => [...prevState, 1]);

      let dateRangeList = [];
      for (let i = 0; i <= diff; i++) {
        let date = new Date(FromDate);
        date.setDate(date.getDate() + i);
        dateRangeList.push(moment(date).format("YYYY-MM-DD"));
      }
      setDateRangeList(() => [...dateRangeList]);
    }
  };

  // useEffect(() => {
  //   fetchingAvailableSlots();
  // }, []);

  // useEffect(() => {
  //   if (selectedDoctor || fromDate || toDate) {
  //     fetchingAvailableSlots();
  //   }
  // }, [selectedDoctor]);

  return (
    <div className={styles.bookAnAppointment}>
      <div className={styles.bookAnAppointment__date__doctor}>
        <div className={styles.bookAnAppointment__doctorList}>
          <div className={styles.bookAnAppointment__searchBar}>
            <SelectBox
              items={doctors}
              searchEnabled={true}
              placeholder=""
              label="Select Doctor"
              labelMode="floating"
              displayExpr="doctor_name"
              valueExpr={"doctor_pms_ref_id"}
              width="93%"
              value={selectedDoctor}
              onSelectionChanged={(e) => {
                setSelectedDoctor(e?.selectedItem?.doctor_pms_ref_id);
                setClickedFetchButton([])
                setInfoText(null)
              }}
            />
          </div>
        </div>
        <div>
          <AppointmentDateCard
            setFromDate={(val) => setFromDate(val)}
            setToDate={(val) => setToDate(val)}
            fromDate={fromDate}
            toDate={toDate}
            fetchingAvailableSlots={fetchingAvailableSlots}
            infoText={infoText}
            setInfoText={setInfoText}
            setDateRangeList={(val)=>setDateRangeList(val)}
          />
        </div>
      </div>
      <div className={styles.bookAnAppointment__time}>
        <DoctorSlots
          fromDate={fromDate}
          toDate={toDate}
          selectedDoctor={selectedDoctor}
          setSelectedTimeSlot={(val) => setSelectedTimeSlot(val)}
          selectedTimeSlot={selectedTimeSlot}
          dateRangeList={dateRangeList}
          selectDoctor={selectDoctor}
          selectAppointmentTime={selectAppointmentTime}
          onClose={onClose}
          selectedAppointmentDate={selectedAppointmentDate}
          clickedFetchButton={clickedFetchButton}
          centerId={centerId}
        />
      </div>
    </div>
  );
};

export default BookAnAppointment;
